<prism-ui-page-content
  key-id="page-content"
  >
  <prism-ui-heading
    font-size="lg"
    font-weight="regular"
    key-id="applicant-info-title"
    is-uppercase="false"
    variant="default"
    >{{pageTitle}}
  </prism-ui-heading>
  
  <!-- Hide the horizontal rule when reviewing/editing from review so
       the page reads as a single-section view, not a wizard step. -->
  @if (!isEditFromReview) {
    <hr class="horizontalLine">
  }

  <prism-ui-copy>
    <p>Please enter the {{applicantType}} information below.</p>
  </prism-ui-copy>
  <form [formGroup]="applicantInfoForm" #formDirective="ngForm" (ngSubmit)="onSubmit()" autocomplete="off">
    <prism-ui-container
      is-compact="false"
      key-id="app-info-container"
      has-shadow="false"
      variant="default"
      has-no-border-radius="false"
      >
      <div class="form-group">
        @if ( applicantType !== 'employee') {
          @if (firstNameToast || dobToast) {
            <div class="toastModal">
              <prism-ui-toast key-id="spouseToast" action="close" size="default" variant="caution"
                (prismUiToastOnClose)="handlePrismUiToastOnClose(dobToast ? 'applicantBirthDateMonth' : 'applicantFirstName')">
                <div slot="heading">
                  <prism-ui-heading key-id="spouseToastTitle" font-size="xs" font-weight="strong" line-height="loose">
                    {{ spouseInformationSoftErrorElement?.label }}
                  </prism-ui-heading>
                </div>
                <prism-ui-copy slot="content" key-id="spouseToastContent" line-height="loose">
                  {{ spouseInformationSoftErrorElement?.error }}
                </prism-ui-copy>
              </prism-ui-toast>
            </div>
          }
          <div class="containerOne">
            <div class="item firstName">
              <prism-ui-form-field
                key-id="applicantFirstName"
                [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantFirstName')"
                >
                <span slot="label">{{ firstNameElement?.label }}</span>
                <span slot="helper-text">{{ firstNameElement?.hint }}</span>
                <span slot="error">
                  @if (applicantFirstName.errors?.pattern) {
                    <span>{{ firstNameElement?.error }}</span>
                  }
                  @if (applicantFirstName.errors?.required) {
                    <span>{{ firstNameElement?.error }}</span>
                  }
                </span>
                <prism-ui-input-text
                  slot="input"
                  is-required="true"
                  [maxLength]="maxLengthName"
                  ngDefaultControl
                  formControlName="applicantFirstName"
                  [name]="applicantFirstNameName"
                  [formGroup]="applicantInfoForm"
                  key-id="applicantFirstName"
                  placeholder="{{firstNameElement?.placeholder}}"
                  [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantFirstName')"
                  (focusout)="firstNameLeaveEvent($event)"
                  autocomplete="new-password"
                  autofill="off"
                ></prism-ui-input-text>
              </prism-ui-form-field>
            </div>
            <div class="item lastName">
              <prism-ui-form-field
                key-id="applicantLastNameName"
                [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantLastName')"
                >
                <span slot="label">{{ lastNameElement?.label }}</span>
                <span slot="helper-text">{{ lastNameElement?.hint }}</span>
                <span slot="error">
                  @if (applicantLastName.hasError('pattern')) {
                    <span>{{ lastNameElement?.error }}</span>
                  }
                  @if (applicantLastName.errors?.required) {
                    <span>{{ lastNameElement?.error }}</span>
                  }
                </span>
                <prism-ui-input-text
                  autocomplete="new-password"
                  autofill="off"
                  slot="input"
                  is-required="true"
                  [maxLength]="maxLengthName"
                  ngDefaultControl
                  formControlName="applicantLastName"
                  [formGroup]="applicantInfoForm"
                  [name]="applicantLastNameName"
                  key-id="applicantLastNameName"
                  placeholder="{{lastNameElement?.placeholder}}"
                  [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantLastName')"
                  (focusout)="lastNameLeaveEvent($event)"
                ></prism-ui-input-text>
              </prism-ui-form-field>
            </div>
            <div class="item ssn">
              <prism-ui-form-field
                key-id="applicantSsnName"
                [isValid]="formControlUtilitiesService.isSsnControlValid(applicantInfoForm, 'applicantSsn')"
                >
                <span slot="label">{{ ssnElement?.label }}</span>
                <span slot="error">
                  @if (applicantSsn.hasError('required')) {
                    <span>{{ ssnElement?.error }}</span>
                  }
                  @if (applicantSsn.hasError('pattern')) {
                    <span>{{ ssnInvalidErrorElement?.error }}</span>
                  }
                  @if (applicantSsn.hasError('invalidSsn')) {
                    <span>{{ ssnInvalidErrorElement?.error }}</span>
                  }
                  @if (applicantSsn.hasError('ssnMatchesEmployee')) {
                    <span>{{ ssnMatchErrorElement?.error }}</span>
                  }
                </span>
              </prism-ui-form-field>
              <div class="container">
                <div class="item ssnBox">
                  <prism-ui-input-ssn
                    aria-label="Enter your social security number"
                    is-small="false"
                    is-valid="true"
                    key-id="applicantSsnName"
                    default-value=""
                    is-hidden="false"
                    autocomplete="new-password"
                    autofill="off"
                    formControlName="applicantSsn"
                    [formGroup]="applicantInfoForm"
                    [name]="applicantSsnName"
                    [isValid]="formControlUtilitiesService.isSsnControlValid(applicantInfoForm , 'applicantSsn')"
                    (focusout)="formControlUtilitiesService.ssnLeaveEvent(applicantInfoForm , 'applicantSsn', hasSsnMatch)"
                    ngDefaultControl
                    (inputSsnChange)="handleChangeEvent($event)"
                    is-hidden="true"
                    >
                  </prism-ui-input-ssn>
                </div>
              </div>
            </div>
            <div class="containerDateHeader">
              <prism-ui-form-field
                key-id="applicantBirthDateName"
                [isValid]="isApplicantBirthDateValid()"
                >
                <span slot="label">{{ dateOfBirthElement?.label }}</span>
                <span slot="helper-text">{{ dateOfBirthElement?.hint }}</span>
                @if (!isApplicantBirthDateValid()) {
                  <span slot="error" >{{ dateOfBirthElement?.error }}</span>
                }
              </prism-ui-form-field>
            </div>
            <div class="containerDateBody">
              <div class="item mm">
                <prism-ui-input-number
                  autocomplete="new-password"
                  autofill="off"
                  slot="input"
                  is-required="true"
                  formControlName="applicantBirthDateMonth"
                  [name]="applicantBirthDateMonthName"
                  key-id="applicantBirthDateMonth"
                  ngDefaultControl
                  placeholder="MM"
                  max="12"
                  min="1"
                  max-length="2"
                  min-length="1"
                  (focusout)="applicantBirthDateMonthLeaveEvent()"
                  [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantBirthDateMonth')"
                ></prism-ui-input-number>
              </div>
              <div class="item dd">
                <prism-ui-input-number
                  autocomplete="new-password"
                  autofill="off"
                  slot="input"
                  is-required="true"
                  formControlName="applicantBirthDateDay"
                  [name]="applicantBirthDateDayName"
                  key-id="applicantBirthDateDay"
                  ngDefaultControl
                  placeholder="DD"
                  max="31"
                  min="1"
                  max-length="2"
                  min-length="1"
                  (focusout)="applicantBirthDateDayLeaveEvent()"
                  [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantBirthDateDay')"
                ></prism-ui-input-number>
              </div>
              <div class="item yyyy">
                <prism-ui-input-number
                  autocomplete="new-password"
                  autofill="off"
                  slot="input"
                  is-required="true"
                  formControlName="applicantBirthDateYear"
                  [name]="applicantBirthDateYearName"
                  key-id="applicantBirthDateYear"
                  ngDefaultControl
                  placeholder="YYYY"
                  max="birthDayStartDate"
                  min="birthDayDatePickerStartAt"
                  max-length="4"
                  min-length="4"
                  (focusout)="applicantBirthDateYearLeaveEvent()"
                  [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantBirthDateYear')"
                ></prism-ui-input-number>
              </div>
            </div>
          </div>
        }

        <div class="item oneCell">
          <prism-ui-copy>
              <p><b>Gender</b></p>
            </prism-ui-copy>
          <prism-ui-form-field-select
            [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'gender')"
            [formFieldItemsCount]="genderRadioButtonOptions.length"
            key-id="genderRadio"
            orientation="horizontal"
            hide-legend="true"
            >
            <span slot="legend">Gender</span>
            <span slot="error">{{ genderElementError }}</span>
            @for (gen of genderRadioButtonOptions; track gen; let index = $index) {
              <div id="gender-{{ index }}" slot="input-{{ index + 1 }}">
                <prism-ui-radio-button
                  [labelText]="gen.label"
                  key-id="genderRadio"
                  ngDefaultControl
                  formControlName="gender"
                  [name]="gen.name"
                  [checked]="applicantInfoForm.get('gender').value === gen.name"
                  [isValid]="isGenderValid"
                  (prismUiRadioButtonOnChange)="logGenderRadioChangeEvent(gen.name)"
                  >
                </prism-ui-radio-button>
              </div>
            }
          </prism-ui-form-field-select>

        </div>
        <div class="item oneCell">
          <div class="alignItems moveHelpIconsUp">
            <prism-ui-copy>
              <p><b>Birthplace</b></p>
            </prism-ui-copy>
            <div class="allPadding moveHelpIconsUp">
              <prism-ui-icon-button
                expanded="false"
                has-tooltip="true"
                icon-name="circle-info"
                is-inactive="false"
                is-waiting="false"
                key-id="helpBirthplace"
                label="{{tooltipBirthplaceDescription}}"
                size="small"
                [tooltipPosition]="birthplaceTooltipPosition"
                type="button"
                variant="tertiary"
                class=""
                >
                <div class="birthplaceTooltipWidth birthplaceTooltipPadding">
                  <prism-ui-copy key-id="birthPlaceTooltip">{{tooltipBirthplaceDescription}}</prism-ui-copy>
                </div>
              </prism-ui-icon-button>
            </div>
          </div>

          <div class="dualRadioHorizontal">
            @for (opt of birthplaceRadioButtonOptions; track opt; let index = $index) {
              <div id="placeOfBirth" slot="input-{{ index + 1 }}">
                <prism-ui-radio-button
                  labelText="{{opt.label}}"
                  [keyId]="opt.name"
                  ngDefaultControl
                  [name]="opt.name"
                  [checked]="applicantInfoForm.get('placeOfBirth').value === opt.name"
                  [isValid]="isBirthPlaceValid"
                  (prismUiRadioButtonOnChange)="logBirthPlaceRadioChangeEvent(opt.name)"
                  >
                </prism-ui-radio-button>
              </div>
            }
          </div>
        </div>
        <div class="item oneCell">
          @if (foreignBirthplace) {
            <prism-ui-form-field
              key-id="countryOfBirthName"
              [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'countryOfBirth')"
              >
              <span slot="label">{{ birthCountryElement?.label }}</span>
              <span slot="helper-text">{{ birthCountryElement?.hint }}</span>
              @if (countryOfBirth.invalid && countryOfBirth.touched) {
                <span slot="error">{{ birthCountryElement?.error }}</span>
              }
              <prism-ui-select
                slot="input"
                key-id="countryOfBirthName"
                has-placeholder="true"
                is-required="true"
                [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'countryOfBirth')"
                [options]="countryOfBirthLabels"
                [selectedValue]="getCountryOfBirthLabel(applicantInfoForm.get('countryOfBirth')?.value)"
                ngDefaultControl
                [formGroup]="applicantInfoForm"
                formControlName="countryOfBirth"
                (selectEvent)="handleOptionSelectedCountryOfBirth($event, 'countryOfBirth')"
                >
              </prism-ui-select>
            </prism-ui-form-field>
          }
          @if (!foreignBirthplace) {
            <prism-ui-form-field
              [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'stateOfBirth')"
              key-id="applicantStateOfBirth"
              >
              <span slot="label">State of Birth</span>
              @if (stateOfBirth.invalid && stateOfBirth.touched) {
                <span slot="error">{{ birthStateElement?.error }}</span>
              }
              <prism-ui-select
                slot="input"
                key-id="stateOfBirth"
                has-placeholder="true"
                is-required="true"
                [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'stateOfBirth')"
                [options]="birthStateLabels"
                [selectedValue]="getStateOfBirthLabel(applicantInfoForm.get('stateOfBirth')?.value)"
                ngDefaultControl
                [formGroup]="applicantInfoForm"
                formControlName="stateOfBirth"
                (selectEvent)="handleOptionSelectedStateOfBirth($event, 'stateOfBirth')"
                >
              </prism-ui-select>
            </prism-ui-form-field>
          }
        </div>
        <div class="item oneCell">
          <prism-ui-form-field
            [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'country')"
            key-id="applicantCountryOfResidence"
            >
            <span slot="label">{{ selectTextCountryOfResidence }}</span>
            <span slot="helper-text">{{ countryElement?.hint }}</span>

            <span slot="error">{{ countryElement?.error }}</span>

            <prism-ui-select
              slot="input"
              key-id="applicantCountryOfResidence"
              has-placeholder="true"
              is-required="true"
              [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'country')"
              [options]="countryLabels"
              [selectedValue]="getCountryofResidenceLabel(applicantInfoForm.get('country')?.value)"
              ngDefaultControl
              [formGroup]="applicantInfoForm"
              formControlName="country"
              (selectEvent)="handleOptionSelectedCountryOfResidence($event, 'country')"
              >
            </prism-ui-select>

          </prism-ui-form-field>
        </div>

        <div class="item oneCell">
          <prism-ui-form-field
            key-id="applicantLine1Name"
            [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantLine1')"
            >
            <span slot="label">{{ addressElement?.label }}</span>
            <span slot="helper-text">{{ addressElement?.hint }}</span>
            <span slot="error">{{ addressElement?.error }}</span>

            <prism-ui-input-text
              autocomplete="new-password"
              autofill="off"
              slot="input"
              is-required="true"
              [maxLength]="maxLengthLine1"
              ngDefaultControl
              formControlName="applicantLine1"
              [formGroup]="applicantInfoForm"
              [name]="applicantLine1Name"
              key-id="applicantLine1Name"
              placeholder="{{addressElement?.placeholder}}"
              [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantLine1')"
              (focusout)="AddressLine1LeaveEvent($event)"
            ></prism-ui-input-text>

          </prism-ui-form-field>
        </div>
        <div class="item oneCell">
          <prism-ui-form-field
            key-id="applicantCityName"
            [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantCity')"
            >
            <span slot="label">{{ cityElement?.label }}</span>
            <span slot="helper-text">{{ cityElement?.hint }}</span>
            <span slot="error">{{ cityElement?.error }}</span>

            <prism-ui-input-text
              autocomplete="new-password"
              autofill="off"
              slot="input"
              is-required="true"
              [maxLength]="maxLengthLine1"
              ngDefaultControl
              formControlName="applicantCity"
              [formGroup]="applicantInfoForm"
              [keyId]="applicantCityName"
              [name]="applicantCityName"
              placeholder="{{cityElement?.placeholder}}"
              [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantCity')"

              (focusout)="CityLeaveEvent($event)"
            ></prism-ui-input-text>

          </prism-ui-form-field>
        </div>

        <div class="containerTwo">
          <div class="item oneCell">
            @if (foreignAddress) {
              <prism-ui-form-field
                key-id="state"
                [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'state')"
                >
                <span slot="label">{{ stateElement?.label }}</span>
                <span slot="helper-text">{{ stateElement?.hint }}</span>
                <span slot="error">{{ stateElement?.error }}</span>
                <prism-ui-input-text
                  autocomplete="new-password"
                  autofill="off"
                  slot="input"
                  is-required="true"
                  [maxLength]="maxLengthState"
                  ngDefaultControl
                  formControlName="state"
                  [formGroup]="applicantInfoForm"
                  [name]="stateName"
                  key-id="state"
                  placeholder="{{stateElement?.placeholder}}"
                  [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'state')"
                  (focusout)="stateLeaveEvent($event)"
                ></prism-ui-input-text>
              </prism-ui-form-field>
            }
            @if (!foreignAddress) {
              <prism-ui-form-field
                key-id="state"
                [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'state')"
                >
                <span slot="label">{{ stateElement?.label }}</span>
                <span slot="helper-text">{{ stateElement?.hint }}</span>
                <span slot="error">{{ stateElement?.error }}</span>
                <prism-ui-select
                  slot="input"
                  key-id="state"
                  has-placeholder="true"
                  is-required="true"
                  [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'state')"
                  [options]="stateRegionListLabels"
                  [selectedValue]="getStateLabel(applicantInfoForm.get('state')?.value)"
                  ngDefaultControl
                  [formGroup]="applicantInfoForm"
                  formControlName="state"
                  (selectEvent)="handleOptionSelectedState($event, 'state')"
                  >
                </prism-ui-select>
              </prism-ui-form-field>
            }
          </div>
          <div class="item oneCell .zipCode">
            @if (foreignAddress) {
              <prism-ui-form-field
                key-id="applicantZipCodeName"
                [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantZipCode')"
                >
                <span slot="label">{{ zipElement?.label }}</span>
                <span slot="helper-text">{{ zipElement?.hint }}</span>
                <span slot="error">{{ zipElement?.error }}</span>
                <prism-ui-input-text
                  autocomplete="new-password"
                  autofill="off"
                  slot="input"
                  is-required="true"
                  [maxLength]="maxLengthZipNonUs"
                  ngDefaultControl
                  formControlName="applicantZipCode"
                  [formGroup]="applicantInfoForm"
                  [name]="applicantZipCodeName"
                  key-id="applicantZipCodeName"
                  placeholder="{{zipElement?.placeholder}}"
                  [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantZipCode')"
                  (focusout)="applicantZipCodeLeaveEvent($event)"
                ></prism-ui-input-text>
              </prism-ui-form-field>
            }
            @if (!foreignAddress) {
              <prism-ui-form-field
                key-id="applicantZipCode"
                [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantZipCode')"
                >
                <span slot="label">{{ zipElement?.label }}</span>
                <span slot="helper-text">{{ zipElement?.hint }}</span>
                <span slot="error">{{ zipElement?.error }}</span>
                <prism-ui-input-text
                  autocomplete="new-password"
                  autofill="off"
                  slot="input"
                  is-required="true"
                  [maxLength]="5"
                  ngDefaultControl
                  formControlName="applicantZipCode"
                  [formGroup]="applicantInfoForm"
                  [name]="applicantZipCodeName"
                  key-id="applicantZipCodeName"
                  placeholder="{{zipElement?.placeholder}}"
                  [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantZipCode')"
                  (focusout)="applicantZipCodeLeaveEvent($event)"
                ></prism-ui-input-text>
              </prism-ui-form-field>
            }
          </div>
        </div>

        <div class="item oneCell">
          @if (foreignAddress) {
            <prism-ui-form-field
              key-id="applicantPhoneName"
              [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantPhone')"
              >
              <span slot="label">{{ phoneElement?.label }}</span>
              <span slot="helper-text">{{ phoneElement?.hint }}</span>
              <span slot="error">
                @if (applicantPhone.hasError('required') || applicantPhone.hasError('maxlength') || applicantPhone.hasError('pattern')) {
                  <span>{{ phoneElement?.error }}</span>
                }
              </span>
              <prism-ui-input-number
                autocomplete="new-password"
                autofill="off"
                slot="input"
                is-required="true"
                ngDefaultControl
                formControlName="applicantPhone"
                [formGroup]="applicantInfoForm"
                [name]="applicantPhoneName"
                [maxLength]="maxLengthPhone"
                key-id="applicantPhoneName"
                placeholder="{{phoneElement?.placeholder}}"
                [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantPhone')"
                (focusout)="phoneLeave()"
              ></prism-ui-input-number>
            </prism-ui-form-field>
          }
          @if (!foreignAddress) {
            <prism-ui-form-field
              key-id="applicantPhoneName"
              [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantPhone')"
              >
              <span slot="label">{{ phoneElement?.label }}</span>
              <span slot="helper-text">{{ phoneElement?.hint }}</span>
              <span slot="error">
                @if (applicantPhone.hasError('required')) {
                  <span>{{ phoneElement?.error }}</span>
                }
                @if (applicantPhone.hasError('pattern')) {
                  <span>{{ phoneElement?.error }}</span>
                }
              </span>
              <prism-ui-input-phone
                autocomplete="new-password"
                autofill="off"
                slot="input"
                is-required="true"
                ngDefaultControl
                formControlName="applicantPhone"
                [formGroup]="applicantInfoForm"
                [name]="applicantPhoneName"
                key-id="applicantPhoneName"
                [placeholder]="phoneMask"
                [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'applicantPhone')"
                (focusout)="phoneLeaveEvent($event)"
              ></prism-ui-input-phone>
            </prism-ui-form-field>
          }
        </div>
        <div class="item oneCell">
          <prism-ui-form-field
            key-id="emailName"
            [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'email')"
            >
            <span slot="label">{{ emailElement?.label }}</span>
            
            @if (email.pending) {
              <span slot="error">Validating...</span>
            }
            @else if (!email.pending && email.status === 'INVALID' && email.touched) {
              <span slot="error">
                @if (email.hasError('required')) {
                  <span>{{ emailElement?.error }}</span>
                }
                @if (email.hasError('pattern')) {
                  <span>{{ emailElement?.error }}</span>
                }
                @if (email.hasError('invalidEmail')) {
                  <span>{{ emailElement?.error }}</span>
                }
              </span>
            }
          </prism-ui-form-field>

          <prism-ui-input-email
            autocomplete="new-password"
            [defaultValue]="emailDefaultValue"
            autofill="off"
            slot="input"
            is-required="true"
            is-small="false"
            ngDefaultControl
            formControlName="email"
            [formGroup]="applicantInfoForm"
            [name]="emailName"
            key-id="emailName"
            placeholder="{{emailElement?.placeholder}}"
            [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'email')"
            (focusout)="emailLeaveEvent($event)"
          ></prism-ui-input-email>

        </div>
        @if (isGenericDynamicForm) {
          <div class="item oneCell">
            <prism-ui-copy>
              <p><b>Preferred Method of Contact</b></p>
            </prism-ui-copy>
            <prism-ui-form-field-select
              [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'communicationPreference')"
              [formFieldItemsCount]="communicationRadioButtonOptions.length"
              key-id="communicationPreferenceRadio"
              orientation="horizontal"
              hide-legend="true"
              >
              <span slot="legend">Preferred Method of Contact</span>
              <span slot="error">{{ commPrefElement?.error }}</span>
              @for (appType of communicationRadioButtonOptions; track appType; let index = $index) {
                <div id="communicationPreference-{{ index }}" slot="input-{{ index + 1 }}">
                  <prism-ui-radio-button
                    [labelText]="appType.label"
                    key-id="communicationPreferenceRadio"
                    ngDefaultControl
                    formControlName="communicationPreference"
                    [name]="appType.name"
                    [checked]="applicantInfoForm.get('communicationPreference').value === appType.name"
                    [isValid]="isCommunicationValid"
                    (prismUiRadioButtonOnChange)="logCommunicationRadioChangeEvent(appType.name)"
                    >
                  </prism-ui-radio-button>
                </div>
              }
            </prism-ui-form-field-select>
            <prism-ui-copy>
              <p>{{commPrefElement?.hint}}</p>
            </prism-ui-copy>
          </div>
        }
        @if (!isGenericDynamicForm) {
          <div class="item oneCell">
            <prism-ui-copy>
              <p><b>Communication Preference</b></p>
            </prism-ui-copy>
            <prism-ui-form-field-select
              [isValid]="formControlUtilitiesService.isControlValid(applicantInfoForm, 'communicationPreference')"
              [formFieldItemsCount]="communicationRadioButtonOptions.length"
              key-id="communicationPreferenceRadio"
              orientation="horizontal"
              hide-legend="true"
              >
              <span slot="legend">Communication Preference</span>
              <span slot="error">{{ commPrefElement?.error }}</span>
              @for (appType of communicationRadioButtonOptions; track appType; let index = $index) {
                <div id="communicationPreference-{{ index }}" slot="input-{{ index + 1 }}">
                  <prism-ui-radio-button
                    [labelText]="appType.label"
                    key-id="communicationPreferenceRadio"
                    ngDefaultControl
                    formControlName="communicationPreference"
                    [name]="appType.name"
                    [checked]="applicantInfoForm.get('communicationPreference').value === appType.name"
                    [isValid]="isCommunicationValid"
                    (prismUiRadioButtonOnChange)="logCommunicationRadioChangeEvent(appType.name)"
                    >
                  </prism-ui-radio-button>
                </div>
              }
            </prism-ui-form-field-select>
            <prism-ui-copy>
              <p>{{commPrefElement?.hint}}</p>
            </prism-ui-copy>
          </div>
        }
      </div>
    </prism-ui-container>
    <div class="row">
      <br>
        @if (isEditFromReview) {
          <prism-ui-button-group
            key-id="applicant-edit-button-group"
            buttons-count="2"
            spacing="default"
            class="editActionButtons"
          >
            <prism-ui-button
              slot="1"
              button-width="full"
              key-id="back-button"
              size="md"
              variant="secondary"
              type="button"
              is-icon-right-aligned="false"
              [attr.is-inactive]="isSavingEdit ? 'true' : null"
              (click)="goBack()"
            >Back</prism-ui-button>
            <prism-ui-button
              slot="2"
              button-width="full"
              key-id="save-button"
              size="md"
              variant="primary"
              type="button"
              is-icon-right-aligned="false"
              [attr.is-inactive]="isSavingEdit ? 'true' : null"
              (click)="saveAndGoToReview()"
            >Save</prism-ui-button>
          </prism-ui-button-group>
        } @else {
          <app-continue-cancel 
              (cancelEmitter)="onCancel()" 
              (backEmitter)="onBack()"
              [showBackButton]="showBackButton"
          ></app-continue-cancel>
        }
      </div>
    </form>
    @if (formSubmitted && !isEditFromReview) {
      <div class="page-loader">
        <prism-ui-loader
          has-logo="false"
          is-reverse="false"
          key-id="page-loader"
          size="md"
          >
        </prism-ui-loader>
        <prism-ui-copy
          font-size="md"
          font-style="normal"
          font-weight="regular"
          key-id="spinner-loading-text"
          line-height="medium"
          text-decoration="none"
          variant="default"
          >
          <span>Please wait while we process your request</span>
        </prism-ui-copy>
      </div>
    }
  </prism-ui-page-content>